import { useVerifyEmailPresenter } from '../../presenter'
import { EmailGoThroughPage } from '../../ui-kit'

export const VerifyEmail = () => <EmailGoThroughPage {...useVerifyEmailPresenter()} buttonText="Continue" />
